import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { SharedModule } from '../shared/shared.module';
import { GrowthDialogComponent } from './components/growth-dialog/growth-dialog.component';
import { PremiumBannerComponent } from './components/premium-banner/premium-banner.component';
import { PremiumIconComponent } from './components/premium-icon/premium-icon.component';

const components = [
  GrowthDialogComponent,
  PremiumIconComponent,
  PremiumBannerComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule, DialogModule],
  declarations: [...components],
  exports: [...components],
})
export class FeaturesModule {}
